<template>
  <v-layout wrap>
    <v-flex xs12 class="text-xs-center">
      <v-dialog v-model="dialog" max-width="900px">
        <v-btn color="btnColor" dark slot="activator" class="mb-2" flat>
          <v-icon>add</v-icon>Add Certificate(s)
        </v-btn>
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Upload Certificate</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click="close">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field v-model="description" label="Certificate Description"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <label>Browse Certificate</label>
                  <file-upload @image="setCertificate"></file-upload>
                  <v-alert :value="true" v-if="fileerror==true" type="error" class="py-2">The file must be an image or pdf in format & a max of 2MB.</v-alert>
                </v-flex>

                <v-flex xs12 sm8 v-if="certImageUrl">
                  <v-layout wrap>
                    <v-flex xs12 sm4>
                      <img
                        v-if="certImageUrl"
                        :src="certImageUrl"
                        style="width: 150px; height: 150px; padding: 20px"
                      >
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-btn icon @click="removeCertImage">
                        <v-icon color="red">clear</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-btn class="primary right" dark @click="save" :loading="loader">
                    <v-icon left>save</v-icon>Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>

    <v-flex xs12>
      <div v-if="user.certificates.length>=1">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs3 sm3 v-for=" (img, i) in user.certificates" :key="i">
              <v-btn icon @click="deleteModal(img)">
                <v-icon color="red">clear</v-icon>
              </v-btn>
              <p>{{img.description}}</p>
              <v-img v-if="img.name.split('.')[1].toLowerCase() != 'pdf'"
                @click="showImage(img.name)"
                :src="`${host}/uploads/certificates/${img.name}`"
                title="Click to view"
                class="pa-3"
              ></v-img>
              <v-btn large v-if="img.name.split('.')[1].toLowerCase() == 'pdf'" :class="{'pa-0 ml-2': $vuetify.breakpoint.smAndDown, 'pa-5 ml-4': $vuetify.breakpoint.mdAndUp}" class="border-class" icon large :href="`${host}/uploads/certificates/${img.name}`" target="_blank">
                <v-icon style="height:auto;" >picture_as_pdf</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-flex>

    <!-- image modal -->
    <v-dialog v-model="imageDialog" max-width="1200px">
      <v-card>
        <v-toolbar flat dense color="light-blue" dark>
          <v-toolbar-title class="title">Certificate preview</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon class="mb-2" @click.native="closeImage">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <img class="modal-img" :src="`${host}/uploads/certificates/${currentImage}`">
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of image modal -->

    <!-- certificate modal -->
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-toolbar flat dense color="red" dark>
          <v-toolbar-title class="title">Certificate Deletion</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon class="mb-2" @click.native="deleteDialog=false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>{{deleteItem.description}}</v-flex>
            <v-flex xs12>
              <v-btn color="red" dark @click="deleteCert" :loading="loader">Delete</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of certificate modal -->

    <!-- start of snackbar -->
    <snackbar ref="mySnackbar"></snackbar>
    <!-- end of snackbar -->
  </v-layout>
</template>

<script>
import FileUpload from "@/components/shared/file-uploader.vue";
import Snackbar from "@/components/global/snackbar.vue";
import { mapGetters } from "vuex";
export default {
  name: "ExpertCertificatesIndex",
  components: {
    FileUpload,
    Snackbar
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["host"])
  },
  data() {
    return {
      dialog: false,
      loader: false,
      description: null,
      images: [],
      imagesUrls: [],
      cerImage: null,
      certImageUrl: null,
      imageDialog: false,
      deleteDialog: false,
      currentImage: null,
      deleteItem: {},
      fileerror: false
    };
  },
  methods: {
    removeCertImage(key) {
      this.certImage = null;
      this.certImageUrl = null;
    },
    deleteModal(data) {
      this.deleteItem = data;
      this.deleteDialog = true;
    },
    setImages(files) {
      this.images = files;
    },
    setImagesUrls(urls) {
      this.imagesUrls = urls;
    },
    setCertificate({ image, imageUrl }) {
      const bytes = (this.calculateImageSize(imageUrl));
      let mimeType = imageUrl.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
      let allowedMimeType = ['application/pdf','image/png', 'image/jpeg', 'image/svg+xml', 'image/gif', 'image/tiff', 'image/webp', 'image/bmp']
      if(allowedMimeType.includes(mimeType) & bytes<=2) {
        this.certImage = image;
        this.certImageUrl = imageUrl;
        this.fileerror = false;
      } else {
        this.fileerror = true;
      }
      
    },
    calculateImageSize(base64String){
      let padding, inBytes, base64StringLength;
      if(base64String.endsWith("==")) padding = 2;
      else if (base64String.endsWith("=")) padding = 1;
      else padding = 0;

      base64StringLength = base64String.length;
      inBytes =(base64StringLength / 4 ) * 3 - padding;
      this.kbytes = inBytes / 1000;
      return this.kbytes / 1000;
    },
    save() {
      const user = this.user;
      user.description = this.description;
      if (this.images.length > 5) {
        this.$refs.mySnackbar.show(
          "You cannot upload more than 5 certificates",
          "red"
        );
      } else {
        const data = new FormData();
        data.append("description", this.description);
        data.append("certificate", this.certImage);
        // submit data
        const self = this;
        self.loader = true;
        const res = this.$store
          .dispatch("put", { url: "/user/update/" + user._id, data })
          .then(res => {
            if (res.status) {
              self.certImage = null;
              self.certImageUrl = null;
              self.description = null;
              self.$store.commit("setUser", res.user);
              self.loader = false;
              self.dialog = false;
            } else {
              self.$refs.mySnackbar.show(res.msg, "red");
              self.dialog = false;
            }
          });
      }
    },
    deleteCert() {
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("remove",  "/user/update/" + self.user._id + '/' + self.deleteItem._id )
        .then(res => {
          console.log(res, 'r');
          if (res) {
            self.$store.commit("setUser", res.user);
            self.deleteDialog = false;
            self.loader = false;
          }
        });
    },
    close() {
      this.dialog = false;
    },
    showImage(img) {
      this.currentImage = img;
      this.imageDialog = true;
    },
    closeImage() {
      this.imageDialog = false;
    }
  }
};
</script>

<style scoped>
.experience {
  font-size: 18px;
}

.collection_thumbs {
  overflow: hidden;
  max-height: 120px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 2px;
  text-align: center;
}
.collection_thumbs img {
  max-height: 100%;
  max-width: 100%;
}
.thumb_image:hover {
  text-align: center;
  content: "Click to remove";
  cursor: pointer;
}
.border-class {
  border-radius: 0;
  border:1px solid #837f7f;
}
</style>

